import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadBatch } from '../api/upload-batch';
import type { IntakeUploadResponse } from '../types';

/** Uploads one batch and reports progress (0–1). On success the patient's inbox is refetched. */
export function useUploadIntakeBatch(patientId: string) {
  const queryClient = useQueryClient();
  const [progress, setProgress] = useState<number | null>(null);

  const mutation = useMutation<IntakeUploadResponse, Error, File[]>({
    mutationFn: (files) => {
      setProgress(0);
      return uploadBatch(patientId, files, { onProgress: setProgress });
    },
    onSettled: () => setProgress(null),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['intake-inbox', patientId] }),
  });

  return { ...mutation, progress };
}
